import React from 'react';
import { Link } from 'react-router-dom';
import BlogArticleLayout, { blogStyles as s } from './BlogArticleLayout';

function BlogArticleViolationDonnees() {
  return (
    <BlogArticleLayout
      tag="RGPD"
      title="Violation de données personnelles : obligations et procédure à suivre"
      date="3 novembre 2026"
      ctaTitle="Préparez votre entreprise avant qu'une violation survienne"
      ctaText="Le diagnostic vérifie si vous disposez déjà d'une procédure de gestion des violations de données, conforme aux exigences du RGPD."
    >
      <p style={s.intro}>
        Une violation de données personnelles n'est pas réservée aux grandes cyberattaques médiatisées : un
        email envoyé au mauvais destinataire, un ordinateur volé non chiffré, ou une erreur de configuration
        peuvent suffire à en déclencher une, avec les mêmes obligations légales à la clé.
      </p>

      <h2 style={s.h2}>Qu'est-ce qu'une violation de données au sens du RGPD ?</h2>
      <p>
        Le RGPD définit une violation de données comme tout incident de sécurité entraînant, de manière
        accidentelle ou illicite, la perte, l'altération, la divulgation ou l'accès non autorisé à des données
        personnelles. Cela couvre aussi bien une intrusion informatique qu'une erreur humaine.
      </p>

      <h2 style={s.h2}>L'obligation de notification à la CNIL sous 72 heures</h2>
      <p>
        Dès que vous avez connaissance d'une violation susceptible d'engendrer un risque pour les personnes
        concernées, vous devez la notifier à la CNIL dans un délai de 72 heures. Ce délai court dès la prise
        de connaissance, pas dès la découverte complète des circonstances — une notification initiale, même
        incomplète, peut être complétée ultérieurement.
      </p>

      <h2 style={s.h2}>Faut-il aussi informer les personnes concernées ?</h2>
      <p>
        Si la violation est susceptible d'engendrer un risque élevé pour les droits et libertés des personnes
        concernées (par exemple une fuite de données bancaires ou de santé), celles-ci doivent également en
        être informées directement, sauf si des mesures rendent les données incompréhensibles pour un tiers
        (chiffrement fort notamment) ou si l'information nécessiterait des efforts disproportionnés.
      </p>

      <h2 style={s.h2}>Tenir un registre interne des violations</h2>
      <p>
        Même une violation qui ne nécessite pas de notification à la CNIL doit être documentée dans un
        registre interne : nature de l'incident, données concernées, mesures prises. Ce registre peut être
        demandé lors d'un contrôle, y compris longtemps après les faits.
      </p>

      <h2 style={s.h2}>Ce qui se joue en cas de non-respect</h2>
      <p>
        Au-delà des sanctions administratives possibles, le non-respect de cette obligation prive surtout
        l'entreprise d'une réaction rapide et maîtrisée, qui limite souvent l'ampleur réelle des conséquences
        pour les personnes concernées comme pour l'entreprise elle-même.
      </p>

      <h2 style={s.h2}>Se préparer avant qu'une violation survienne</h2>
      <p>
        Une procédure interne écrite, qui précise qui alerter, comment qualifier rapidement la gravité, et
        comment documenter les faits, change radicalement la gestion d'une violation le jour où elle survient.
        Voir notre article
        {' '}<Link to="/blog/que-faire-apres-cyberattaque" style={s.link}>Que faire après une cyberattaque</Link>{' '}
        pour la marche à suivre plus large, et notre
        {' '}<Link to="/blog/rgpd-cybersecurite-ce-que-toute-entreprise-doit-savoir" style={s.link}>guide RGPD</Link>{' '}
        pour resituer cette obligation dans l'ensemble de vos obligations RGPD.
      </p>

      <p style={s.disclaimer}>
        Cet article a une vocation informative et ne remplace pas une analyse juridique personnalisée par un
        professionnel du droit ou votre DPO.
      </p>
    </BlogArticleLayout>
  );
}

export default BlogArticleViolationDonnees;
